export default __webpack_public_path__ + "static/media/bilikis.c5c209a0.webp";